import { render, staticRenderFns } from "./DPE.vue?vue&type=template&id=527b57d2&"
import script from "./DPE.vue?vue&type=script&lang=js&"
export * from "./DPE.vue?vue&type=script&lang=js&"
import style0 from "./DPE.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports